export * from "./resourceActions";
export * from "./eventActions";
export * from "./singlePageActions";
export * from "./yearOfActionResourceActions";
export * from "./tagActions";
export * from "./newsActions";
export * from "./menuActions";



// WEBPACK FOOTER //
// ./src/store/actions/index.js